import { createFileRoute } from '@tanstack/react-router';
import CandidateMailTemplateFormTemplate from '@/features/agent/candidate_mails/templates/CandidateMailTemplateFormTemplate';

type CandidateMailTemplateNewSearch = {
  sourceId?: number;
};

export const Route = createFileRoute('/agent/candidate_mails/templates/new')({
  component: RouteComponent,
  staticData: { title: 'テンプレート作成' },
  validateSearch: (search: Record<string, unknown>): CandidateMailTemplateNewSearch => {
    const sourceId = Number(search.sourceId);
    return { sourceId: Number.isInteger(sourceId) && sourceId > 0 ? sourceId : undefined };
  },
});

function RouteComponent() {
  const { sourceId } = Route.useSearch();
  return <CandidateMailTemplateFormTemplate sourceTemplateId={sourceId} />;
}
